<div class="modal-body width-500">
	<div class="layout-auto-1-auto">
		<span class="modal-header">
			{{enumSvc.getFieldCaption('Receipt','rcptObject')}}
		</span>
		<div class="content height-700">
			<div class="layout-auto-1">
				<!-- Search Header -->
				<exg-search-bar [placeholder]="getRessource('SearchHolder')"
				                (Search)="search($event)"
				                class="span-layout">
				</exg-search-bar>
				<div class="content">
					<ng-container *ngFor="let enm of getReceiptObjectList(); let i = index;">
						<exg-switch name="{{enm.enmText}}" style="align-self: start; overflow: visible"
						            [caption]="enm.enmText"
						            [(ngModel)]="enm.enmValue"
						            [tooltip]="enm.uiTooltip"></exg-switch>
					</ng-container>
				</div>
			</div>
		</div>
		<div class="spawn-modal-actions grid-1-auto">
			<div class="typo-small">
				({{getRessource('countTrue', {countTrue: countTrue})}})
			</div>
			<div class="typo-small">
				<button (click)="cancel()" class="md-btn">
					{{getGlobal('Cancel')}}
				</button>
				<button (click)="save()" class="md-btn">
					{{getGlobal('Save')}}
				</button>
			</div>
		</div>
	</div>
</div>
